interface ArbitrumIconProps {
  className?: string
  size?: number
  colored?: boolean
}

export const ArbitrumIcon: React.FC<ArbitrumIconProps> = ({
  className,
  size = 24,
  colored = false,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="80 80 340 340"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M297.814 99.624H264.636C262.107 99.624 259.945 101.139 259.062 103.551L152.189 396.449C151.424 398.346 152.953 400.376 154.968 400.376H188.147C190.676 400.376 192.838 398.861 193.72 396.449L300.594 103.551C301.359 101.654 299.829 99.624 297.814 99.624ZM239.694 99.624H206.515C203.986 99.624 201.824 101.139 200.941 103.551L94.1855 396.332C93.4207 398.229 94.9502 400.258 96.965 400.258H130.143C132.673 400.258 134.835 398.743 135.717 396.332L242.473 103.551C243.238 101.654 241.841 99.624 239.694 99.624ZM282.755 213.086C281.872 210.424 278.063 210.424 277.181 213.086L259.959 260.442C259.459 261.706 259.459 263.221 259.959 264.501L308.08 396.332C308.962 398.611 311.124 400.258 313.653 400.258H346.832C348.861 400.258 350.376 398.229 349.611 396.332L282.755 213.086ZM407.615 396.332L311.756 133.435C310.874 130.773 307.065 130.773 306.182 133.435L288.961 180.79C288.461 182.055 288.461 183.57 288.961 184.849L366.083 396.332C366.965 398.611 369.127 400.258 371.657 400.258H404.836C406.864 400.258 408.379 398.229 407.615 396.332Z"
        fill={colored ? '#28A0F0' : 'currentColor'}
      />
    </svg>
  )
}
